const drinks = [
    {
        id:1,
        name: 'organic juice',
        price: '2.00'
    },
    {
        id:2,
        name: 'coffee',
        price: '3.00'
    },
    {
        id:3,
        name: 'spirits',
        price: '5.00'
    }
];

export default drinks;